import React, { Component } from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { required } from '../../util/validationFunctions'
import InputText from '../comun/form/InputText'
import InputCheckBox from '../comun/form/InputCheckBox'
import InputSelect from 'react-select'
import InputNumerical from '../comun/form/InputNumerical'
import InputTextArea from '../comun/form/InputTextArea'
import Dropzone from 'react-dropzone'
import { Unarchive } from '@material-ui/icons'
import './ImportarContactosExcel.scss'

class ImportarContactosExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      archivos: '',
      archivoCargado: false
    }
  }

  onDrop (archivos) {
    archivos.map((archivo, i) => {
      var reader = new FileReader();
      reader.onloadend = () => {
        archivo.content=reader.result
        this.props.actions.subirArchivosImportarContactosExcel({name: archivo.name, file: reader.result})
        this.setState({archivos: {name: archivo.name, file: reader.result}})
        this.setState({archivoCargado: true})
      }
      reader.readAsDataURL(archivo)
    })
  }

  submitImportarContactosExcel () {
    this.props.actions.submitImportarContactosExcel(this.state.archivos)
    this.setState({archivoCargado: false})
  }

  cerrarModalImportarContactosExcel () {
    this.props.actions.cerrarModalImportarContactosExcel()
    this.setState({archivos: ''})
    this.setState({archivoCargado: false})
  }

  descargarPlantillaExcelContactosExcel () {
    this.props.actions.descargarPlantillaExcelContactosExcel()
  }

  render () {
    const {
      t, handleSubmit, showModalImportarContactosExcel, archivoExcel, listImportarContactosExcel
      } = this.props

    if(!showModalImportarContactosExcel) return null

    let errorImportar = listImportarContactosExcel.filter(item => item.insertado===false)    
    let totalImportados = listImportarContactosExcel.length;
    let totalErrores = errorImportar.length;
    let totalCorrectos = totalImportados - totalErrores;
    return (
      <Modal show={showModalImportarContactosExcel} onHide={() => this.cerrarModalImportarContactosExcel()} aria-labelledby="contained-modal-title-lg" backdrop="static" className="form-carga-index">
      <form>
        <Modal.Header closeButton>
          <Modal.Title>
          {t('IMPORTAR_CONTACTOS_EXCEL.TITLE')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <div className="archivos-carga-index">
              <Dropzone
                accept=".xls,.xlsx"
                onDrop={this.onDrop.bind(this)}
                uploadMultiple={true}
                maxFiles={null}
                // maxSize={200000}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}  className="custom-file-label">
                    <input {...getInputProps()} />
                    <label><span className="explorar-input-file">{t('COPIA_SEGURIDAD.SUBIR_ARCHIVO')}</span></label>
                  </div>
                )}
              </Dropzone>
            </div>
            {
              Object.keys(archivoExcel).length > 0 ? (
                <p className="nombre-archivo-subido"><Unarchive />{archivoExcel.name}</p>
              ) : null
            }
            {
              totalImportados > 0 && (
                <div className="resultado-importar-clientes">
                  <p>
                    <strong>{t('IMPORTAR_CONTACTOS_EXCEL.RESUMEN')}</strong><br />
                    {t('IMPORTAR_CONTACTOS_EXCEL.IMPORTADOS_CORRECTAMENTE', { correctos: totalCorrectos, total: totalImportados })}
                  </p>
                </div>
              )
            }            
            {
              Object.keys(errorImportar).length > 0 ? (
                <div className="resultado-importar-clientes error-importar">                  
                  <ul>      
                    <li><strong>{t('IMPORTAR_CONTACTOS_EXCEL.ERROR')}</strong></li>              
                    {
                      errorImportar.map((contacto, idx) => (
                        <li key={idx}>
                          <div>* {contacto.partyNumberD365 || contacto.nombreDireccion}</div>                          
                        </li>
                      ))
                    }
                  </ul>
                </div>
              ) : Object.keys(listImportarContactosExcel).length > 0 ? (
                <div className="resultado-importar-contactos">                
                  <ul>                                          
                    <li>{t('IMPORTAR_CONTACTOS_EXCEL.DOCUMENTO_SUBIDO')}</li>                      
                  </ul>                                      
                </div>
              ) : null
            }
          </Row>
        </Modal.Body>
        <Modal.Footer>          
          <Button type="button" onClick={() => this.descargarPlantillaExcelContactosExcel()} className="btn btn-primary">{t('IMPORTAR_CONTACTOS_EXCEL.DESCARGAR_EJEMPLO_EXCEL')}</Button>
          {
            Object.keys(listImportarContactosExcel).length === 0 ? (
              <Button type="button" onClick={() => this.submitImportarContactosExcel()} className="btn btn-primary">{t('CARGA_INDEX.ACEPTAR')}</Button>
            ) : null
          }
          <Button type="button" className="btn btn-white" onClick={() => this.cerrarModalImportarContactosExcel()}>{t('CARGA_INDEX.CANCELAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ImportarContactosExcel',
})(ImportarContactosExcel))